//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';

import overflowDetectorFactory from 'common/components/core/util/OverflowDetector';
import theme from './OverflowDetectorPopover.scss';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';

class TooltipWithOverflow extends React.Component<$FlowFixMeProps> {
    render() {
        const {
            textOverflow,
            overflowText,
            children,
            theme,
            className,
            ...others
        } = this.props;
        return (
            <DivWithPopover
                className={classnames(theme.overflowDiv, className)}
                theme={theme}
                popOverContent={textOverflow ? overflowText : null}
                triggerPopoverOn={PopoverTriggerEnum.Hover}
                {...others}
            >
                {children}
            </DivWithPopover>
        );
    }
}

const OverflowDetectorPopover = overflowDetectorFactory({
    WrappedComponent: TooltipWithOverflow
});
const ThemedOverflowDetectorPopover = themr(
    'OverflowDetectorPopover',
    theme
)(OverflowDetectorPopover);

export { ThemedOverflowDetectorPopover as OverflowDetectorPopover };
export default ThemedOverflowDetectorPopover;
